const getDialogTitle = (name: string) => `Are you sure you want to delete connection with ${name}?`;

export { getDialogTitle };
